$('.slick-carousel').each((_, el) => {
  const $el = $(el);
  if($el.length) {
    const prevArrowHtml = '<button type="button" class="slick-prev slick-arrow" style=""><svg class="icon icon-chevron-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 17"><path fill="#FFF" d="M.838 1.184L1.495.43l9.47 8.248-9.47 8.248-.657-.754 8.605-7.494z"></path></svg></button>';
    const nextArrowHtml = '<button type="button" class="slick-next slick-arrow" style=""><svg class="icon icon-chevron-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 17"><path fill="#FFF" d="M.838 1.184L1.495.43l9.47 8.248-9.47 8.248-.657-.754 8.605-7.494z"></path></svg></button>';
    const slidesToShow = $el.data('slides-to-show') ? $el.data('slides-to-show') : 4;
    const unslickMobile = $el.data('unslick-mobile') ? $el.data('unslick-mobile') : false;

    if (unslickMobile) {
      $el.slick({
        arrows: true,
        infinite: true,
        slidesToShow,
        slidesToScroll: 1,
        prevArrow: prevArrowHtml,
        nextArrow: nextArrowHtml,
        responsive: [
          {
            breakpoint: 768,
            settings: "unslick"
          }
        ]
      });
    }

    else {
      $el.slick({
        arrows: true,
        infinite: true,
        slidesToShow,
        slidesToScroll: 1,
        prevArrow: prevArrowHtml,
        nextArrow: nextArrowHtml
      });
    }
  }
});
